import React, { useState, useEffect } from "react";
import { Dropdown, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import { toTimestamp } from "../utilities/functions";
import { PropagateLoader } from "react-spinners";

interface NotificationsProps {
  id_notification: number;
  id_user: number;
  type: string;
  message: string;
  severity: number;
  timestamp: string;
  state: number;
  username?: string;
  email?: string;
}

export function Notifications() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { id_notification } = useParams<{ id_notification?: string }>();
  const { translate } = useTranslate();

  const id_user = localStorage.getItem("userid");

  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [list_Notifications, setNotifications] = useState<NotificationsProps[]>([]);
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);

  const [column, setSortColum] = useState("id_notification");
  const [sort, setSort] = useState("DESC");
  const [search, setSearch] = useState(id_notification || "");
  const [type, setType] = useState(0);
  const [typeSearch, setTypeSearch] = useState(translate("notification") + " ID");

  const [selectedColumns, setSelectedColumns] = useState({
    id_notification: true,
    type: true,
    message: true,
    severity: true,
    state: true,
    timestamp: true,
    username: true,
    email: false,
  });

  const getNotifications = async (
  limitValue: number,
  pageValue: number,
  searchValue: string,
  typeValue: number,
  columnValue: string,
  sortValue: string
) => {
  try {
    setLoading(true);

    const bodyData = JSON.stringify({
      limitValue,
      currentPage: pageValue,
      search: searchValue,
      type: typeValue,
      id_user, // 🔥 SEULEMENT ça
      column: columnValue, // 🔥 UN SEUL champ
      sort: sortValue,
    });

    // ===== TOTAL =====
    const totalPagesResponse = await fetch(
      `${backendUrl}/api/notification/totalpage`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: bodyData,
      }
    );

    const totalPagesJson = await totalPagesResponse.json();
    const totalCount = totalPagesJson?.[0]?.count || 0;

    setTotal(totalCount);
    setPageCount(Math.ceil(totalCount / limitValue));

    // ===== LIST =====
    const response = await fetch(
      `${backendUrl}/api/notification/search`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: bodyData,
      }
    );

    const data = await response.json();

    setNotifications(Array.isArray(data) ? data : []);
    setLimit(limitValue);
    setCurrentPage(pageValue);

  } catch (error) {
    console.error(error);
    setNotifications([]);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    getNotifications(limit, currentPage, search, type, column, sort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = async (data: any) => {
    const nextPage = data.selected + 1;
    await getNotifications(limit, nextPage, search, type, column, sort);
    window.scrollTo(0, 0);
  };

  const handleSelectChange = async (event: any) => {
    const newLimit = parseInt(event.target.value, 10);
    await getNotifications(newLimit, 1, search, type, column, sort);
    window.scrollTo(0, 0);
  };

  const handleColumnChange = (columnName: keyof typeof selectedColumns) => {
    setSelectedColumns((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const handleTypeSearch = (event: any) => {
    const selectedValue = event.target.textContent;

    switch (selectedValue) {
      case translate("notification") + " ID":
        setType(0);
        break;
      case translate("Type"):
        setType(1);
        break;
      case translate("Message"):
      case translate("Details"):
        setType(2);
        break;
      case translate("User"):
        setType(3);
        break;
      default:
        setType(0);
        break;
    }

    setTypeSearch(selectedValue);
  };

  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    await getNotifications(limit, 1, newValue, type, column, sort);
  };

  const handleSortingColum = async (currentColumn: string) => {
    const nextSort = sort === "ASC" ? "DESC" : "ASC";
    setSortColum(currentColumn);
    setSort(nextSort);
    await getNotifications(limit, 1, search, type, currentColumn, nextSort);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <h4>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </span>{" "}
            {translate("notifications")} ({total})
          </h4>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4" style={{ margin: "0px 0px 10px 0px", padding: "10px" }}>
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <i className="fas fa-chevron-down" style={{ fontSize: "20px" }}></i>
              </Dropdown.Toggle>
              <Dropdown.Menu onClick={handleTypeSearch}>
                <Dropdown.Item>{translate("notification") + " ID"}</Dropdown.Item>
                <Dropdown.Item>{translate("Type")}</Dropdown.Item>
                <Dropdown.Item>{translate("Message")}</Dropdown.Item>
                <Dropdown.Item>{translate("User")}</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <input
              type="text"
              placeholder={`${typeSearch}`}
              value={search}
              onChange={handleAdvancedSearch}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="dataTables_length" id="DataTables_Table_0_length">
            <label style={{ marginBottom: "0" }}>
              {translate("Show")}
              <select
                className="custom-select custom-select-sm form-control form-control-sm ml-2"
                style={{ width: "66px" }}
                value={limit}
                onChange={handleSelectChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </label>
          </div>

          <Dropdown>
            <Dropdown.Toggle variant="" id="dropdown-columns" title="Colonnes dʼaffichage">
              <i className="las la-eye"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {Object.keys(selectedColumns).map((key) => (
                <Dropdown.Item
                  key={key}
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns[key as keyof typeof selectedColumns]}
                    onChange={() => handleColumnChange(key as keyof typeof selectedColumns)}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate(key)}</span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="row m-1">
        <Table className="dataTable">
          <thead className="bg-white text-uppercase">
            <tr className="ligth ligth-data">
              <th>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" />
                </div>
              </th>

              {selectedColumns.id_notification && (
                <th className="sorting" onClick={() => handleSortingColum("id_notification")}>
                  {translate("Code")}
                </th>
              )}

              {selectedColumns.type && (
                <th className="sorting" onClick={() => handleSortingColum("type")}>
                  {translate("Type")}
                </th>
              )}

              {selectedColumns.message && (
                <th className="sorting" onClick={() => handleSortingColum("message")}>
                  {translate("Message")}
                </th>
              )}

              {selectedColumns.severity && (
                <th className="sorting" onClick={() => handleSortingColum("severity")}>
                  {translate("Severity")}
                </th>
              )}

              {selectedColumns.state && (
                <th className="sorting" onClick={() => handleSortingColum("state")}>
                  {translate("State")}
                </th>
              )}

              {selectedColumns.timestamp && (
                <th className="sorting" onClick={() => handleSortingColum("timestamp")}>
                  {translate("Date")}
                </th>
              )}

              {selectedColumns.username && (
                <th className="sorting" onClick={() => handleSortingColum("username")}>
                  {translate("User")}
                </th>
              )}

              {selectedColumns.email && (
                <th className="sorting" onClick={() => handleSortingColum("email")}>
                  {translate("Email")}
                </th>
              )}
            </tr>
          </thead>

          <tbody className="ligth-body">
            {loading ? (
              <tr>
                <td className="text-center" colSpan={9}>
                  <PropagateLoader color={"#123abc"} loading={loading} size={20} />
                </td>
              </tr>
            ) : list_Notifications.length > 0 ? (
              list_Notifications.map((notification) => (
                <tr key={notification.id_notification}>
                  <td>
                    <div className="form-check form-check-inline">
                      <input type="checkbox" className="form-check-input" />
                    </div>
                  </td>

                  {selectedColumns.id_notification && <td>{notification.id_notification}</td>}
                  {selectedColumns.type && <td>{notification.type}</td>}
                  {selectedColumns.message && <td>{notification.message}</td>}
                  {selectedColumns.severity && <td>{notification.severity}</td>}

                  {selectedColumns.state && (
                    <td>
                      {notification.state === 1 ? (
                        <span className="badge badge-warning">{translate("Unread")}</span>
                      ) : (
                        <span className="badge badge-success">{translate("Read")}</span>
                      )}
                    </td>
                  )}

                  {selectedColumns.timestamp && <td>{toTimestamp(notification.timestamp)}</td>}
                  {selectedColumns.username && <td>{notification.username || "-"}</td>}
                  {selectedColumns.email && <td>{notification.email || "-"}</td>}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9}>{translate("no_notification_available")}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <span>
            {translate("Displaying")} {list_Notifications.length} {translate("out of")} {total}
          </span>
        </div>

        <div className="col-md-6">
          <ReactPaginate
            previousLabel={translate("previous")}
            nextLabel={translate("next")}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
    </>
  );
}